<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Operations and Maintenance
          </div>
        </v-layout>
        <v-container>
          <OpsNew
          :data="{btnTitle: 'Ops Notification', btnSize: 'flat'}"
          v-if="true"/>
          <WorkRequestNew
          :data="{btnTitle: 'Work Request', btnSize: 'flat'}"
          v-if="
          this.getUser.pref.select.fauth !== null
          "/>
          <IncidentNew
          :data="{btnTitle: 'Create Event', btnSize: 'flat'}"
          v-if="
          this.getUser.pref.select.fauth !== null
          "/>
          <EngNew
          :data="{btnTitle: 'Engineering Study', btnSize: 'flat'}"
          v-if="
          this.getUser.pref.select.fauth !== null
          "/>
        </v-container>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Asset Management
          </div>
        </v-layout>
        <v-container>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              health_and_safety
            </v-icon>
            Health and Safety
          </v-btn>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              savings
            </v-icon>
            Cost Review
          </v-btn>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              co2
            </v-icon>
            Carbon Review
          </v-btn>
        </v-container>
        <v-container>
          <v-layout row>
            <v-spacer/>
            <StatsReadCard :data="{tag: 'A1'}" v-if="false"/>
            <!-- <StatsReadCardOpen :data="{tag: this.getDetail.basic.tag}"/> -->
            <!-- <RevisionReadCard v-if="true"/> -->
            <GetDocumentLogListPage :data="{size: 'icon'}"/>
          </v-layout>
        </v-container>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import OpsNew from "@/operations/notification/components/OpsNew";
import IncidentNew from "@/safety/incident/components/IncidentNew";
import WorkRequestNew from "@/work/request/components/WorkRequestNew";
import EngNew from "@/engineering/engineering/components/EngNew";
import GetDocumentLogListPage from "@/document/log/components/GetDocumentLogListPage";
import StatsReadCard from "@/support/stats/components/StatsReadCard";

export default {
  mixins: [apptheme],
  components: {
    OpsNew,
    WorkRequestNew,
    EngNew,
    IncidentNew,
    GetDocumentLogListPage,
    StatsReadCard
  }
};
</script>
